import React from "react";
import { LEAVE_STATUS } from "./leaveFormat";

/** pending amber · approved green · rejected red · cancelled gray */
const LeaveStatusBadge = ({ status }) => {
  const meta = LEAVE_STATUS[status] || { label: status || "—", tone: "gray" };
  return (
    <span className={`status-pill status-pill--${meta.tone}`}>
      {meta.label}
    </span>
  );
};

export default LeaveStatusBadge;
